export default "__VITE_ASSET__a10661a5__"